// TODO: Consider storing these Nav labels as markdown so they can be added to
//       the Content Model so we can edit in Netlify CMS.
const navItems = [
  {
    title: 'Home',
    path: '/',
  }, {
    title: 'About Project Tracker',
    path: '/about',
  },
];

export default navItems;
